module.exports = " <ly-basemodel title=停用 :class=\"isShow? '' : 'hide'\" v-ref:model> <form class=form-horizontal> <label>*停用原因</label> <div style=\"text-align: center;margin-top:5px\"> <textarea style=\"width:80%;height:150px;resize:none;background-color: #393e46;border-radius: 4px;padding:4px\" v-model=formdata.text></textarea> </div> </form> <button type=button class=\"btn btn-primary\" slot=button @click=submit>确定</button> </ly-basemodel> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/install/disable.vue
 ** module id = 82
 ** module chunks = 0
 **/